import { db } from "../../../../mp-database"

/**
 * Fetches destructured subtests for the groupUA,
 * pulling from destructuredSubtests collection
 * @param {object} assessmentSubtests the assessmentSubtests for the groupUA
 * @returns {object} the destructuredSubtests object
 */
export default function fetchDestructuredSubtests(assessmentSubtests) {
  // get truthy subtests
  let subtestIds = []
  const keys = Object.keys(assessmentSubtests)
  keys.forEach(key => {
    if (assessmentSubtests[key]) {
      subtestIds.push(key)
    }
  })
  // for each subtest, get the destructuredSubtest data
  const fetches = subtestIds.map(id => {
    return db.collection("destructuredSubtests").doc(id).get()
  })
  return Promise.all(fetches).then(results => {
    let destructuredSubtests = {}
    results.forEach(doc => {
      if (doc.exists) {
        destructuredSubtests[doc.id] = doc.data()
      }
    })
    return destructuredSubtests
  })
}
